<template>
  <FormSection>
    <BaseHeading v-if="confirmStepData.header" :level="2">{{ confirmStepData.header }}</BaseHeading>

    <BaseRichtext v-if="confirmStepData.text" class="mb-4">{{ confirmStepData.text }}</BaseRichtext>

    <!-- NOTE: The markup content below was commented out so it could easily be reintegrated in the case that
    the customer requests for it in the near future. -->

    <!-- <p v-if="isComponentTicketType && isTransportationDamageType">
      <span>{{ $t('complaintForm.transportEvaluation.yourExperience') }} </span>
      <span>
        <a :href="$t('complaintForm.transportEvaluation.surveyLink')" target="_blank"
          >{{ $t('complaintForm.transportEvaluation.surveyText') }}
        </a>
      </span>
      <span>{{ $t('complaintForm.transportEvaluation.yourFeedback') }} </span>
    </p> -->

    <div v-show="showSurvey" ref="survey" :class="$style.survey" class="mb-4" />
  </FormSection>
</template>

<script>
import { get } from 'lodash-es'
import { formatISO } from 'date-fns'

import { mapGetters } from 'vuex'

import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_GETTER from '@/js/components/Forms/ComplaintForm/_store-module/getter-types.js'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

import FormSection from '@/js/components/Forms/FormSection.vue'
import { showOrderSurvey } from '@/js/helper/zenloop-order-survey.js'

export default {
  name: 'ComplaintFormConfirm',
  components: {
    FormSection,
  },
  data() {
    return {
      showSurvey: false,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      customerNumber: APP_GETTER.CUSTOMER_NUMBER,
      username: APP_GETTER.USERNAME,
      zenloopSurveys: APP_GETTER.ZENLOOP_SURVEYS,
    }),
    ...mapGetters(FORM_CONSTANTS.STORE_ID, {
      steps: FORM_GETTER.STEPS,
      calculationDesire: FORM_GETTER.CALCULATION_DESIRE,
      ticketType: FORM_GETTER.TICKET_TYPE,
      formData: FORM_GETTER.FORM_DATA,
    }),
    confirmStepData() {
      return get(this.steps, FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.STEPS.CONFIRM)
    },
    isEngineTicketType() {
      return this.ticketType === FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.ENGINE
    },
    isComponentTicketType() {
      return this.ticketType === FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.TICKET_TYPES.COMPONENT
    },
    isTransportationDamageType() {
      return (
        this.calculationDesire ===
        FORM_CONSTANTS.CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_TRANSPORTATION_DAMAGE
      )
    },
    bikeSerialnumber() {
      return this.formData?.serialNo1
        ? `${this.formData.serialNo1}${this.formData?.serialNo2}`
        : undefined
    },
  },
  mounted() {
    if (!this.isEngineTicketType || !this.zenloopSurveys?.order) {
      return
    }

    const recipient = {
      identity: `${this.customerNumber}-${formatISO(new Date())}`,
      identity_type: 'custom',
      properties: {
        type: 'service-engine',
        customerNumber: this.customerNumber,
        username: this.username,
      },
    }

    if (this.bikeSerialnumber) {
      recipient.properties.bikeSerialnumber = this.bikeSerialnumber
    }

    this.showSurvey = true

    showOrderSurvey({
      recipient,
      element: this.$refs.survey,
      survey: this.zenloopSurveys.order,
    })
  },
}
</script>
<style lang="scss" module>
.survey {
  position: relative;
  z-index: 1;

  border: 1px solid var(--grey-lighten-1);
}
</style>
